"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const recording_event_type_1 = require("./recording-event-type");
exports.RecordingUserInteractionEvents = [
    recording_event_type_1.RecordingEventType.Scroll,
    recording_event_type_1.RecordingEventType.MouseMove,
    recording_event_type_1.RecordingEventType.Click,
    recording_event_type_1.RecordingEventType.InputText,
];
//# sourceMappingURL=user-interactions.js.map